// #region Imports

/* Axios */
import axios from 'axios';

/* Telestream */
import { ConnectionService } from '@/services/connection.service';

// #endregion Imports

export function extractVideoPropsFromQueryParams() {
  const urlParams = new URLSearchParams(window.location.search);

  const videoPath = urlParams.get('path');
  const audioPaths = urlParams.getAll('sidecarAudioPaths');
  const startFrame = Number(urlParams.get('startFrame'));
  const frameCount = Number(urlParams.get('frameCount'));
  const playheadOffset = Number(urlParams.get('playheadOffset'));
  const token = urlParams.get('token');
  const open = (/true/i).test(urlParams.get('open'));

  return {
    videoPath,
    audioPaths,
    startFrame,
    frameCount,
    playheadOffset,
    token,
    open
  };
}

export function extractAudioPropsFromQueryParams() {
  const urlParams = new URLSearchParams(window.location.search);

  const track = Number(urlParams.get('track'));
  const soundField = urlParams.get('soundfield');
  const left = Number(urlParams.get('left'));
  const right = Number(urlParams.get('right'));

  return {
    track,
    soundField,
    left,
    right,
  };
}

export function extractFileBrowserPropsFromQueryParams() {
  const urlParams = new URLSearchParams(window.location.search);

  const isHidden = urlParams.get('filebrowser') === 'false';

  return {
    isHidden,
  };
}

export function extractCaptionPropsFromQueryParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const subtitles = urlParams.getAll('subtitle');

  return {
    subtitles,
  };
}

export function extractAutoPlayPropsFromQueryParams() {
  const urlParams = new URLSearchParams(window.location.search);
  return {
    autoplay: urlParams.has('autoplay')
  };
}

export function extractLayoutFromQueryParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const layoutParam = urlParams.get('layout');
  if (!layoutParam) {
    return undefined;
  }

  const layoutValue = Number(layoutParam);
  const layout = {
    header: layoutValue & 0b00000001
  };

  return layout;
}

export async function generateMasterManifestUrl(baseUrl) {
  const response = await axios.get(baseUrl);
  return response.request.responseURL;
}

export function generateBaseUrl(videoPath, audioPaths, startFrame, frameCount, token, element, growingFile) {
  const encodedPath = encodeURIComponent(videoPath);

  const root = token ? `/link${token}` : '/play';
  const resolution = `${screen.width}x${screen.height}` + `,${element.clientWidth}x${element.clientHeight}`;

  let url =
    `${root}/master.m3u8?path=${encodedPath}` +
    `&startFrame=${startFrame ? startFrame : 0}` +
    `&frameCount=${frameCount ? frameCount : 0}` +
    `&res=${resolution}` +
    `&open=${growingFile ? true : false}`;

  if (audioPaths && audioPaths.length > 0) {
    for (const audioPath of audioPaths) {
      url += `&sidecarAudioPaths=${encodeURIComponent(audioPath)}`;
    }
  }

  return ConnectionService.getUrl(url);
}

export function generateClipLink(videoPath, audiotrack, sidecarAudio, startFrame, frameCount, subtitles) {
  let cliplink = `${window.location.origin}/?path=${encodeURIComponent(videoPath)}`;

  if (audiotrack?.track !== undefined) {
    cliplink += `&track=${audiotrack?.track}`;
  }

  if (audiotrack?.currentSoundfield !== undefined) {
    cliplink += `&soundfield=${audiotrack?.currentSoundfield}`;
    cliplink += `&left=${audiotrack?.left}`;
    cliplink += `&right=${audiotrack?.right}`;
  }

  if (startFrame !== undefined) {
    cliplink += `&startFrame=${startFrame}`;
  }

  if (frameCount !== undefined) {
    cliplink += `&frameCount=${frameCount}`;
  }

  if ((subtitles !== undefined) && (subtitles.length > 0)) {
    subtitles.forEach(s => cliplink += `&subtitle=${encodeURIComponent(s)}`);
  }

  if (sidecarAudio && sidecarAudio.length > 0) {
    for (const audioPath of sidecarAudio) {
      cliplink += `&sidecarAudioPaths=${encodeURIComponent(audioPath)}`;
    }
  }

  cliplink += '&filebrowser=false';

  return cliplink;
}
